(function () {
  'use strict';

  var source = document.currentScript;
  if (!source) return;

  var options = {
    desktopBottom: parseInt(source.dataset.desktopBottom || '108', 10),
    mobileBottom: parseInt(source.dataset.mobileBottom || '150', 10),
    hideGreeting: source.dataset.hideGreeting !== 'false',
    mobileSocial: source.dataset.mobileSocial !== 'false',
    mobileSocialWidth: parseInt(source.dataset.mobileSocialWidth || '280', 10)
  };

  var hostId = 'smart-bot-container';
  var styleId = 'vzy-smart-conversion-style';
  var snapNotiStyleId = 'vzy-snapnoti-style';
  var purchasePattern = /(s-a cumpărat|a cumpărat|cumpărat recent|tocmai a cumpărat|a achiziționat|a finalizat comanda|comandă finalizată|completed their order|order completed|recent purchase|just bought|purchased)/i;
  var rootObserver = null;
  var bodyObserver = null;
  var bootObserver = null;
  var scanPending = false;
  var collisionPending = false;
  var collisionEventsBound = false;

  function isStickyProduct() {
    return document.body && document.body.classList.contains('vzy-qb-sticky-present');
  }

  function isThemePreview() {
    return Boolean(document.getElementById('OnlineStorePreviewBarNextData'));
  }

  function syncHostState(host) {
    if (!host) return;
    if (isStickyProduct()) {
      host.setAttribute('data-vzy-sticky-product', '');
    } else {
      host.removeAttribute('data-vzy-sticky-product');
    }
    if (isThemePreview()) {
      host.setAttribute('data-vzy-theme-preview', '');
    } else {
      host.removeAttribute('data-vzy-theme-preview');
    }
    host.setAttribute('data-vzy-mobile-social', options.mobileSocial ? 'true' : 'false');
  }

  function syncChatCollision(host) {
    if (!host || window.innerWidth > 749) {
      if (host) host.removeAttribute('data-vzy-alt-collision');
      return;
    }

    var bubble = host.shadowRoot && host.shadowRoot.querySelector('[class*="_chat-icon-container_"]');
    if (!bubble) {
      host.removeAttribute('data-vzy-alt-collision');
      return;
    }

    var bubbleRect = bubble.getBoundingClientRect();
    var sensitive = 'main h1, .vzy-smart-alt__card, .vzy-card__pricing, .vzy-card__rating, .vzy-card__title, .vzy-card__cta, .vzy-product-band__header, .vzy-promo-chooser, [data-vzy-purchase-price], [data-vzy-purchase-promo], [data-vzy-purchase-packages], [data-vzy-purchase-actions], .vzy-tabs-v2__header, .vzy-tabs-v2__nav, .vzy-phone-order, .main-cart .cart-item__remove, .main-cart .cart-item__quantity, .main-cart .cart-item__prices, .main-cart .cart-item__totals, .vzy-return-form__consent, .vzy-return-form__submit, .product__info-container .product-icon-list, .product__info-container .shopify-app-block, footer.footer a, footer.footer p, footer.footer .rte';
    var points = [[.15, .15], [.85, .15], [.5, .5], [.15, .85], [.85, .85]];
    var overlaps = points.some(function (point) {
      var x = bubbleRect.left + bubbleRect.width * point[0];
      var y = bubbleRect.top + bubbleRect.height * point[1];
      return document.elementsFromPoint(x, y).some(function (element) {
        return element !== host && Boolean(element.closest(sensitive));
      });
    });
    host.toggleAttribute('data-vzy-alt-collision', overlaps);
  }

  function scheduleChatCollision(host) {
    if (collisionPending) return;
    collisionPending = true;
    window.requestAnimationFrame(function () {
      collisionPending = false;
      syncChatCollision(host);
    });
  }

  function findFixedCard(element, root) {
    var current = element;
    while (current && current !== root) {
      if (window.getComputedStyle(current).position === 'fixed') return current;
      current = current.parentElement;
    }
    return element;
  }

  function scanSmartBot(root) {
    if (!root) return;

    root.querySelectorAll('[role="region"][aria-label="Notification"]').forEach(function (region) {
      var text = (region.textContent || '').trim();
      if (purchasePattern.test(text)) {
        region.setAttribute('data-vzy-recent-purchase', '');
        region.removeAttribute('data-vzy-chat-greeting');
      } else {
        region.setAttribute('data-vzy-chat-greeting', '');
      }
    });

    root.querySelectorAll('[role="status"], [role="region"], [class*="sale"], [class*="recent"], [class*="purchase"]').forEach(function (element) {
      var text = (element.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text || text.length > 320 || !purchasePattern.test(text)) return;
      var card = findFixedCard(element, root);
      card.setAttribute('data-vzy-recent-purchase', '');
      card.removeAttribute('data-vzy-chat-greeting');
    });
  }

  function scheduleScan(root) {
    if (scanPending) return;
    scanPending = true;
    window.requestAnimationFrame(function () {
      scanPending = false;
      scanSmartBot(root);
    });
  }

  function installSnapNotiStyles() {
    if (document.getElementById(snapNotiStyleId)) return;
    // Observe Digital's horizontal header without forcing its initial layout.
    var toastHeader = null;
    var toastHeaderHeight = null;
    var toastHeaderObserver = null;

    function writeToastHeaderOffset(height) {
      var nextHeight = Math.max(60, Math.ceil(Number(height) || 0));
      if (nextHeight === toastHeaderHeight) return;
      toastHeaderHeight = nextHeight;
      document.documentElement.style.setProperty('--vzy-toast-header-height', nextHeight + 'px');
    }

    if ('ResizeObserver' in window) {
      toastHeaderObserver = new window.ResizeObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target !== toastHeader) return;
          var boxes = entry.borderBoxSize;
          var box = boxes && (boxes[0] || boxes);
          var height = box && Number.isFinite(box.blockSize)
            ? box.blockSize
            : entry.target.getBoundingClientRect().height;
          writeToastHeaderOffset(height);
        });
      });
    }

    function syncToastHeaderOffset() {
      var nextHeader = document.querySelector('header.header') || document.querySelector('header');
      if (nextHeader !== toastHeader) {
        if (toastHeaderObserver && toastHeader) toastHeaderObserver.unobserve(toastHeader);
        toastHeader = nextHeader;
        if (toastHeaderObserver && toastHeader) {
          toastHeaderObserver.observe(toastHeader, { box: 'border-box' });
        }
      }
      if (!toastHeader) writeToastHeaderOffset(60);
      else if (!toastHeaderObserver) writeToastHeaderOffset(toastHeader.getBoundingClientRect().height);
    }
    syncToastHeaderOffset();
    window.addEventListener('resize', syncToastHeaderOffset, { passive: true });
    document.addEventListener('shopify:section:load', syncToastHeaderOffset);
    var snapStyle = document.createElement('style');
    snapStyle.id = snapNotiStyleId;
    snapStyle.textContent = [
      '.st__timestamp-notification { display: none !important; }',
      'body .st__toast-ol[data-y-position="top"] { top: var(--vzy-toast-header-height, 60px) !important; margin-top: 12px !important; }',
      'body.vzy-phone-modal-open :is(.st__toast-li, #smart-bot-container) { opacity: 0 !important; visibility: hidden !important; pointer-events: none !important; }',
      ':is(.st__block--order-notification-landscape-list-small, .st__block--order-notification-landscape-list-medium) .st__block--content-landscape { height: auto !important; min-height: 0 !important; padding-block: 10px !important; justify-content: center !important; }',
      ':is(.st__block--order-notification-landscape-list-small, .st__block--order-notification-landscape-list-medium) .st__content-landscape-bottom { margin-top: 4px !important; }',
      'body.overflow-hidden-drawer .st__toast-li, body:has(cart-drawer.active, header details[open], dialog[open], .product-media-modal[open], #shopify-pc__banner:not([style*="display: none"]):not([hidden])) .st__toast-li { opacity: 0 !important; visibility: hidden !important; pointer-events: none !important; }',
      'body:has(cart-drawer.active, header details[open], dialog[open], .product-media-modal[open], #shopify-pc__banner:not([style*="display: none"]):not([hidden])) #smart-bot-container { visibility: hidden !important; pointer-events: none !important; }',
      'html[data-scheme="dark"] :is(.vzy-policy-native, .vzy-returns) { background: #11161c !important; color: #d8e3ef !important; }',
      'html[data-scheme="dark"] :is(.vzy-policy-native__section, .vzy-returns__shell, .vzy-returns__process, .vzy-returns__layout) { color: #d8e3ef !important; }',
      'html[data-scheme="dark"] :is(.vzy-policy-native__hero, .vzy-returns__hero) { background: radial-gradient(circle at 86% 10%, rgba(21, 102, 224, .2), transparent 28rem), linear-gradient(135deg, #172431 0%, #101820 58%, #14263a 100%) !important; color: #f5f9ff !important; }',
      'html[data-scheme="dark"] .vzy-returns__form-section { background: #151e28 !important; color: #d8e3ef !important; }',
      'html[data-scheme="dark"] .vzy-returns__privacy-note { border-color: rgba(114, 169, 255, .18) !important; background: #17222d !important; color: #c3d0dc !important; }',
      '@media (prefers-color-scheme: dark) {',
      '  html[data-scheme="auto"] :is(.vzy-policy-native, .vzy-returns) { background: #11161c !important; color: #d8e3ef !important; }',
      '  html[data-scheme="auto"] :is(.vzy-policy-native__section, .vzy-returns__shell, .vzy-returns__process, .vzy-returns__layout) { color: #d8e3ef !important; }',
      '  html[data-scheme="auto"] :is(.vzy-policy-native__hero, .vzy-returns__hero) { background: radial-gradient(circle at 86% 10%, rgba(21, 102, 224, .2), transparent 28rem), linear-gradient(135deg, #172431 0%, #101820 58%, #14263a 100%) !important; color: #f5f9ff !important; }',
      '  html[data-scheme="auto"] .vzy-returns__form-section { background: #151e28 !important; color: #d8e3ef !important; }',
      '  html[data-scheme="auto"] .vzy-returns__privacy-note { border-color: rgba(114, 169, 255, .18) !important; background: #17222d !important; color: #c3d0dc !important; }',
      '}',
      '@media (max-width: 600px) {',
      '  :is(.st__block--order-notification-landscape-list-small, .st__block--order-notification-landscape-list-medium) .st__block--content-landscape { padding-block: 8px !important; }',
      '}'
    ].join('\n');
    document.head.appendChild(snapStyle);
  }

  function install() {
    var host = document.getElementById(hostId);
    if (!host || !host.shadowRoot) return false;

    syncHostState(host);
    var root = host.shadowRoot;
    var style = root.getElementById(styleId);

    if (!style) {
      style = document.createElement('style');
      style.id = styleId;
      style.textContent = [
        '[class*="_chat-icon-container_"] { left: 20px !important; right: auto !important; bottom: 20px !important; transition: transform 180ms ease, bottom 180ms ease, left 180ms ease, opacity 160ms ease, visibility 160ms ease !important; }',
        ':host([data-vzy-sticky-product]) [class*="_chat-icon-container_"] { left: 20px !important; right: auto !important; bottom: ' + options.desktopBottom + 'px !important; }',
        ':host([data-vzy-theme-preview][data-vzy-sticky-product]) [class*="_chat-icon-container_"] { bottom: ' + (options.desktopBottom + 68) + 'px !important; }',
        options.hideGreeting ? '[data-vzy-chat-greeting] { display: none !important; }' : '',
        '[data-vzy-recent-purchase] { max-width: min(320px, calc(100vw - 32px)) !important; border-radius: 14px !important; box-shadow: 0 14px 34px rgba(1, 22, 36, .18) !important; }',
        '[data-vzy-recent-purchase] [class*="close"] { min-width: 32px !important; min-height: 32px !important; }',
        '@media (max-width: 749px) {',
        '  [class*="_chat-icon-container_"] { left: 6px !important; right: auto !important; bottom: 12px !important; transform: scale(.8666667); transform-origin: left bottom; }',
        '  :host([data-vzy-sticky-product]) [class*="_chat-icon-container_"] { left: 6px !important; right: auto !important; bottom: ' + options.mobileBottom + 'px !important; transform: scale(.8666667); transform-origin: left bottom; }',
        '  :host([data-vzy-theme-preview][data-vzy-sticky-product]) [class*="_chat-icon-container_"] { bottom: ' + (options.mobileBottom + 68) + 'px !important; }',
        '  :host([data-vzy-alt-collision]) [class*="_chat-icon-container_"] { opacity: 0 !important; visibility: hidden !important; pointer-events: none !important; }',
        '  :host([data-vzy-mobile-social="true"]) [data-vzy-recent-purchase] { left: auto !important; right: 12px !important; bottom: ' + options.mobileBottom + 'px !important; width: min(' + options.mobileSocialWidth + 'px, calc(100vw - 88px)) !important; max-width: calc(100vw - 88px) !important; }',
        '  :host([data-vzy-mobile-social="false"]) [data-vzy-recent-purchase] { display: none !important; }',
        '}',
        '@media (prefers-reduced-motion: reduce) { * { animation-duration: .01ms !important; animation-iteration-count: 1 !important; transition-duration: .01ms !important; } }'
      ].join('\n');
      root.prepend(style);
    }

    scanSmartBot(root);
    scheduleChatCollision(host);

    if (!rootObserver) {
      rootObserver = new MutationObserver(function () {
        scheduleScan(root);
        scheduleChatCollision(host);
      });
      rootObserver.observe(root, { childList: true, subtree: true });
    }

    if (!bodyObserver && document.body) {
      bodyObserver = new MutationObserver(function () {
        syncHostState(host);
        scheduleChatCollision(host);
      });
      bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }

    if (!collisionEventsBound) {
      window.addEventListener('scroll', function () { scheduleChatCollision(host); }, { passive: true });
      window.addEventListener('resize', function () { scheduleChatCollision(host); }, { passive: true });
      collisionEventsBound = true;
    }

    return true;
  }

  installSnapNotiStyles();

  if (!install()) {
    bootObserver = new MutationObserver(function () {
      if (install() && bootObserver) {
        bootObserver.disconnect();
        bootObserver = null;
      }
    });
    bootObserver.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () {
      if (bootObserver) {
        bootObserver.disconnect();
        bootObserver = null;
      }
    }, 15000);
  }
})();
